import React, { useEffect, useState } from 'react';
import { FiLoader } from 'react-icons/fi';
import { PROCESSING_EVENT, ProcessingEventDetail } from '../utils/processing';
import '../styles/ProcessingIndicator.css';

const ProcessingIndicator: React.FC = () => {
  const [state, setState] = useState<ProcessingEventDetail>({
    active: false,
    count: 0,
    message: 'Processando...',
  });

  useEffect(() => {
    const handler = (event: Event) => {
      const custom = event as CustomEvent<ProcessingEventDetail>;
      setState(custom.detail);
    };
    window.addEventListener(PROCESSING_EVENT, handler);
    return () => window.removeEventListener(PROCESSING_EVENT, handler);
  }, []);

  if (!state.active) return null;
  return (
    <div className="processing-indicator" role="status" aria-live="polite">
      <FiLoader className="processing-spinner" />
      <span>{state.message}</span>
      {state.count > 1 && <small>{state.count} operações</small>}
    </div>
  );
};

export default ProcessingIndicator;
